import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import useAnalyticUtils from 'src/composables/analyticUtils';
const analyticUtils = useAnalyticUtils();

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => {
      return { left: 0, top: 0 };
    },
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.afterEach((to, from, failure) => {
    if (!failure) {
      const propertyCode = to.params['propertyCode'] as string;
      if (propertyCode) {
        analyticUtils.trackPageView(propertyCode, to.fullPath);
      }
    }
  });

  /*
  Force full page load if we fail to load a module.
  */
  Router.onError((error, to) => {
    if (
      (error.message &&
        (error.message.includes(
          'Failed to fetch dynamically imported module',
        ) ||
          error.message.includes('Importing a module script failed'))) ||
      error.message.includes('error loading dynamically imported module')
    ) {
      window.location.href = to.fullPath;
    }
  });

  return Router;
});
